import { render, staticRenderFns } from "./Cell.vue?vue&type=template&id=18847d24&scoped=true&"
import script from "./Cell.vue?vue&type=script&lang=js&"
export * from "./Cell.vue?vue&type=script&lang=js&"
import style0 from "./Cell.vue?vue&type=style&index=0&id=18847d24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18847d24",
  null
  
)

export default component.exports